import { Styles, Theme } from 'react-select'
import { presets, colors } from 'assets'
import { CSSProperties } from 'react'
import { applyStyle } from './utils'

export const selectStyles: Partial<Styles> = {
  container: applyStyle({
    height: 'fit-content',
    textTransform: 'none',
    textAlign: 'left'
  }),
  control: applyStyle(state => ({
    border: 0,
    boxShadow: state.isFocused ? presets.boxShadow : 'unset',
    height: '100%',
    '& > svg': { marginLeft: 10 }
  })),
  valueContainer: applyStyle({
    padding: '5px 10px'
  }),
  multiValue: applyStyle({
    backgroundColor: colors.backgroundLight,
    height: 22,
    maxWidth: 90,
    borderRadius: 22,
    padding: '0 5px'
  }),
  multiValueLabel: applyStyle({
    color: colors.black,
    textTransform: 'none',
    fontSize: 10,
    margin: 'auto'
  }),
  indicatorSeparator: applyStyle({
    display: 'none'
  }),
  multiValueRemove: applyStyle({
    ':hover': { backgroundColor: 'unset' }
  } as CSSProperties),
  option: applyStyle({
    // '&:hover': {
    //   backgroundColor: colors.grey
    // },
    // ':active': {
    //   backgroundColor: colors.grey
    // }
  } as CSSProperties),

  // multiValueRemove
}

export const applyTheme = (theme: Theme): Theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: colors.backgroundColor
  }
})
